import React from "react";
import PropTypes from "prop-types";
import { Route, Redirect } from "react-router-dom";
import Header from '../../components/Header';
import functionCommon from "../common/function";

export default function RouteWrapper({
    component: Component,
    data: data,
    isPrivate,
    isHeader,
    isStaff,
    isStaffManager,
    isDirector,
    isStaffSupervisor,
    isError,
    isLeave,
    isHr,
    ...rest
}) {
    let signed = functionCommon.requireAuth();
    let roleUser = functionCommon.getRole();
    let levelUser = functionCommon.getLevel();

    if (!signed && !isPrivate && !isError) {
        return functionCommon.logout();
    }

    if (signed && isPrivate) {
        return <Redirect to="/update-working-hour" />;
    }
    
    if (roleUser === 'staff' && !isStaff && !isStaffManager && !isDirector && !isStaffSupervisor && !isLeave) {
        return <Redirect to="/update-working-hour" />;
    }

    if (roleUser === 'staff' && levelUser === 'staff' && isStaffManager && !isLeave) {
        return <Redirect to="/update-working-hour" />;
    }

    if (roleUser === 'staff' && levelUser === 'staff' && isDirector && !isLeave) {
        return <Redirect to="/update-working-hour" />;
    }

    if (roleUser === 'staff' && levelUser !== 'staff' && levelUser !== 'supervisor' && isDirector & !isStaffManager && !isLeave) {
        return <Redirect to="/update-working-hour" />;
    }

    if (roleUser === 'director' && !isStaff && !isStaffManager && !isDirector && !isStaffSupervisor && !isLeave) {
        return <Redirect to="/update-working-hour" />;
    }

    if (isLeave && (roleUser === "staff" || roleUser === 'director' || roleUser === 'admin') && isHr) {
        return <Redirect to="/my-leave-request" />;
    }

    if (isLeave && roleUser === "staff" && levelUser === "staff" && isStaff) {
        return <Redirect to="/my-leave-request" />;
    }

    if (isHeader) {
        return <Route {...rest}><section className="body-content">{data}</section></Route>;
    } else if (!rest.path) {
        return <Route {...rest}><section className="body-content error-page">{data}</section></Route>;
    } else if (rest.path && rest.path.indexOf("error") !== -1) {
        return <Route {...rest}><section className="body-content error-page">{data}</section></Route>;
    } else {
        return <Route {...rest}><Header /><section className="body-content has-header">{data}</section></Route>;
    }
}

RouteWrapper.propTypes = {
    isPrivate: PropTypes.bool,
    isHeader: PropTypes.bool,
    isStaff: PropTypes.bool,
    isStaffManager: PropTypes.bool,
    isDirector: PropTypes.bool,
    isStaffSupervisor: PropTypes.bool,
    isError: PropTypes.bool,
    data: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
    component: PropTypes.oneOfType([PropTypes.element, PropTypes.func])
};

RouteWrapper.defaultProps = {
    isPrivate: false,
    isHeader: false,
    isStaff: false,
    isStaffManager: false,
    isDirector: false,
    isStaffSupervisor: false,
    isError: false
};
